import { useTranslation } from "react-i18next";

import TextFieldSearch from "@plannel/components/TextFieldSearch";

/**
 * `SearchOptsGroup`(Master, §10)의 Report 전용 변형 — Report는 조회조건이 바뀌면 항상
 * 백엔드 재조회가 필요하고(클라 필터 없음, `fp-report-screen-guide.md` §A-3b), 화면 전체
 * 조회 버튼도 없다(같은 문서 §A-9b, 전 Report 화면 공통 정책) — 그래서 텍스트 입력은
 * **매 키 입력마다 재조회하지 않고, 필드 안의 검색 아이콘/Enter로만 수동 커밋**한다.
 * `master-plan/reports/OrderTracking.js`의 `TextFieldSearch` 사용 선례와 동일한 패턴
 * (자유 텍스트 = uncontrolled ref + 수동 커밋, 선택형 조건만 즉시 자동조회).
 *
 * `common/component/SearchOptsGroup.js`(Master, controlled value/onChange)는 건드리지
 *않는다 — Master 화면들이 그 즉시-반영 계약에 의존하므로 공용 파일 수정 금지 규칙 대상.
 *
 * props:
 *  - fieldRefs: { [tpCd]: React.RefObject<string> } — 화면이 미리 만든 ref 전체(값 소유권은
 *    화면에 있지만 controlled state가 아니라 ref — 매 키 입력마다 리렌더/재조회를 안 하기 위함)
 *  - fieldKeys: string[] — 이번 렌더링에서 보여줄 필드 키 목록(고정)
 *  - labels: { [tpCd]: i18nKey }
 *  - retrieve: () => void — Enter 또는 필드 내 검색 아이콘 클릭 시 호출(화면의 조회 함수 그대로 공유)
 */
const SearchOptsGroupRetrieve = ({ fieldRefs, fieldKeys, labels = {}, retrieve }) => {
  const { t } = useTranslation();

  return fieldKeys.map(tpCd => (
    <TextFieldSearch
      key={tpCd}
      label={t(labels[tpCd] ?? tpCd)}
      searchCode={fieldRefs[tpCd]}
      retrieve={retrieve}
      size="small"
      // SearchOptsGroup(Master)의 text 케이스와 동일한 간격/폭(minWidth:150) — FilterContainer 안에서
      // PlanScope 등 다른 컨트롤과 나란히 놓일 때 수직 정렬이 맞아야 한다(SearchOptsGroup.js 주석 참고).
      // width가 아니라 minWidth인 이유도 Master와 동일 — 아이콘 등으로 내용이 넓어져야 하면 늘어나게 둔다.
      sx={{ ml: 1.5, minWidth: 150 }}
    />
  ));
};

export default SearchOptsGroupRetrieve;
